import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import FeaturedBooks from './components/FeaturedBooks';
import Calendar from './components/Calendar';
import Coffee from './components/Coffee';
import Visit from './components/Visit';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <FeaturedBooks />
        <About />
        <Calendar />
        <Coffee />
        <Visit />
      </main>
      <Footer />
    </div>
  );
}

export default App;
